export const AirtableIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M9.06403 2.68938L2.5395 5.45552C2.17667 5.60937 2.18043 6.1375 2.54553 6.28578L9.09727 8.94784C9.67291 9.18176 10.314 9.18176 10.8896 8.94784L17.4415 6.28568C17.8065 6.1375 17.8104 5.60947 17.4474 5.45562L10.9231 2.68927C10.3278 2.43691 9.65917 2.43691 9.06393 2.68927"
        fill="#FCB400"
      />
      <path
        d="M10.5742 10.4025V17.0527C10.5742 17.369 10.8855 17.5856 11.1725 17.4691L18.4731 14.5656C18.5545 14.5325 18.6244 14.4752 18.6736 14.4009C18.7228 14.3267 18.7491 14.239 18.7491 14.1493V7.49909C18.7491 7.18278 18.4378 6.96619 18.1508 7.08275L10.8502 9.98622C10.7688 10.0193 10.699 10.0767 10.6497 10.1509C10.6005 10.2252 10.5742 10.3127 10.5742 10.4025Z"
        fill="#18BFFF"
      />
      <path
        d="M8.87033 10.7448L6.70366 11.8167L6.48367 11.9257L1.90997 14.1711C1.62015 14.3144 1.25 14.0979 1.25 13.7679V7.52617C1.25 7.40678 1.30975 7.30371 1.38987 7.22618C1.42274 7.19264 1.46003 7.16398 1.50065 7.14104C1.60986 7.07385 1.76575 7.05591 1.8983 7.10962L8.83393 9.92533C9.18647 10.0686 9.21416 10.5747 8.87033 10.7448Z"
        fill="#F82B60"
      />
      <path
        d="M8.87109 10.7448L6.70442 11.8167L1.39062 7.22607C1.4235 7.19257 1.46079 7.16395 1.50141 7.14104C1.61062 7.07385 1.76651 7.05591 1.89906 7.10962L8.83469 9.92533C9.18722 10.0686 9.21492 10.5747 8.87109 10.7448Z"
        fill="black"
        fillOpacity="0.25"
      />
    </svg>
  );
};
